<template>
	<div class="fifthView">
		<div class="dec mainCont"  v-html="content"></div>
		<div class="box mainCont" v-if="false">
			<div class="left">
				<ul>
					<li>
						<img src="../../../../static//about/qitem4-img2.png" alt="">
						<div class="txt">
							<span class="label">联系电话</span>
							<p>16541564545</p>
						</div>
					</li>
					<li>
						<img src="../../../../static//about/qitem4-img1.png" alt="">
						<div class="txt">
							<span class="label">公司地址</span>
							<p>郑州市金水区中央商务区格拉姆大厦508</p>
						</div>
					</li>
				</ul>

			</div>
			<div class="right">
				<img src="../../../../static//about/zp.png" alt="">
			</div>
		</div>
			
	</div>
</template>

<script>
	import {getArtice} from '@/api/api'
	import {formatRichText} from "@/utils/utils"
	export default {
		name: 'fifthView',
		components: {},
		data() {
			return {
				articeObj:{},
				content:'',
			};
		},
		mounted() {
			this.getArtice();
		},
		methods: {
			// 加入我们
			getArtice(){
				getArtice({type:'9'}).then(res => {
					this.articeObj = res.data;
					this.content = formatRichText(res.data.content)
				})
			},
		},
	};
</script>

<style lang="scss" scoped>
	.fifthView {padding-top: 56px;padding-bottom: 150px;
		.box{display: flex;align-items: center;background-color: #F5F8F9;
			.left{width: 50%;height: 284px;
				ul{padding-left: 64px;padding-top:64px;
					li{display: flex;align-items: center;margin-bottom: 40px;
						img{width: 56px;}
						.txt{margin-left: 30px;
							.label{color: 14px;color: #A4A9B7;}
							p{font-size: 18px;margin-top: 14px;color: #1F263F;}
						}
					}
				}
			}
			.right{width: 50%;background-color: #EFF3FB;height: 284px;
				img{width: 100%;height: 284px;object-fit: cover;}
			}
		}
		.dec{color: #1F263F;font-size: 16px;margin-bottom: 26px;line-height: 30px;
			p{color: #1F263F;font-size: 16px;margin-bottom: 26px;line-height: 30px;
				&:last-child{margin-bottom: 0;}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/aboutUs/components/fifthView.vue